import { ChangeDetectionStrategy, Component, HostBinding, Input, OnChanges } from '@angular/core';

import { EventModel } from '@frontend/sports/betting-offer/feature/model';

import { EpcotConfigService } from '../../common/epcot-config.service';
import { PodType, TopEventsPodData } from '../top-events.model';

@Component({
    selector: 'ms-top-events-pod-metadata',
    templateUrl: 'top-events-pod-metadata.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class TopEventsPodMetadataComponent implements OnChanges {
    @HostBinding('class') className = 'pod-metadata';

    @Input() pod: TopEventsPodData;

    metaData?: string;
    event?: EventModel;
    disableBadges = true;

    constructor(private epcotConfigService: EpcotConfigService) {}

    ngOnChanges(): void {
        if (!this.epcotConfigService.isEnabled()) {
            this.disableBadges = this.pod.podType !== PodType.BetBuilder;
        }
        this.metaData = this.event = undefined;
        this.setModel();
    }

    private setModel(): void {
        if (this.pod.metaData) {
            this.metaData = this.pod.metaData;
        } else if (
            !this.pod.hideMetadataFallback &&
            [PodType.BetBuilder, PodType.HandpickedOptionsPod, PodType.Single].includes(this.pod.podType) &&
            this.pod.events?.length === 1
        ) {
            this.event = this.pod.events[0];
        }
    }
}
